import React, { PureComponent } from 'react'
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Legend,
  Sector,
  Cell,
} from 'recharts'

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#82ca9d']
const style = {
  top: '50%',
  right: '-40%',
  transform: 'translate(0, -50%)',
  lineHeight: '24px',
}
export default function CourseReport({ courseReportDate }) {
  console.log('courseReportDate', courseReportDate)

  const RADIAN = Math.PI / 180
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5
    const x = cx + radius * Math.cos(-midAngle * RADIAN)
    const y = cy + radius * Math.sin(-midAngle * RADIAN)

    return (
      <text
        x={x}
        y={y}
        fill='white'
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline='central'>
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    )
  }

  return (
    <div
      className='course-report-container'
      style={{ height: 400, width: 450 }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            dataKey='value'
            cx='50%'
            cy='50%'
            labelLine={false}
            data={courseReportDate}
            label={renderCustomizedLabel}>
            {courseReportDate.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Legend
            iconSize={15}
            layout='vertical'
            verticalAlign='middle'
            wrapperStyle={style}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}
